/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// @ts-ignore
import s from './Multiaxis.css';

import CustomChart from '../../../components/CustomChart/CustomChart'
import { multiaxisD3 } from '../../../chart';
import { CustomizedForm } from '../components/baseForm'
import baseFiled from '../components/baseFiled';
import MultiaxisPane from '../components/Multiaxis'
import { isArray } from 'util';
import { saveFile, convertCanvasToImage } from '../../../utils';

const checkPx = (str) => {
  let _str = str + '';
  if (_str.indexOf('%')) {
    return _str;
  } else {
    return _str + 'px'
  }
}

const colorList = [{
  name: '左侧纵坐标',
  value: 'yLeft',
  color: '#ffd70d'
}, {
  name: '右侧纵坐标',
  value: 'yRight',
  color: '#bfbebf'
}, {
  name: '标注连线',
  value: 'labelLine',
  color: '#000'
}, {
  name: '条形图标注颜色',
  value: 'barLabel',
  color: '#000'
}, {
  name: '折线图标注颜色',
  value: 'lineLabel',
  color: '#000'
}]

const createListItem = (list, name, value) => {
  let dataListItem = {
    name: name || ''
  }
  list.forEach(element => {
    dataListItem[element.value] = value||0
  });
  return dataListItem
}

const calcPx = (num, px) => {
  let result = num
  if (num.indexOf('%')) {
    result = (num.replace('%', '') - 0) * px / 100
  }
  return result
}

const list2obj = (list) => {
  let result = {}
  list.forEach(item => {
    result[item.xAxis] = item
  })

  return result
}


class MultiaxisD3 extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      fields: {
        ...Object.assign(baseFiled, {
          titleText: {
            value: 'Apple、华为、三星内容条数对比'
          },
          subTitleText: {
            value: '2019.11.01-2019.11.10'
          }
        })
      },
      axis: 'horizontal',
      list: [],
      labelList: [],
      colorList,
      chartWidth: '100%',
      chartHeight: '100%',
      chart: {},
      chartD3: null
    }

    this.handleFormChange = this.handleFormChange.bind(this);
    this.handleAdd = this.handleAdd.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    const d = [{"name":"2019.11.01","agreeable":"2037","neutrality":"5659"},{"name":"2019.11.02","agreeable":"5276","neutrality":"3309"},{"name":"2019.11.03","agreeable":"2851","neutrality":"4059"},{"name":"2019.11.04","agreeable":"4819","neutrality":"2519"},{"name":"2019.11.05","agreeable":"5869","neutrality":"3945"},{"name":"2019.11.06","agreeable":"2458","neutrality":"1923"},{"name":"2019.11.07","agreeable":"3498","neutrality":"12418"},{"name":"2019.11.08","agreeable":"5832","neutrality":"3481"},{"name":"2019.11.09","agreeable":"5482","neutrality":"3757"},{"name":"2019.11.10","agreeable":"8471","neutrality":"2385"}]

    this.setState({
      list: d,
      labelList: [
        {xAxis:'2019.11.01','label':'标注111','yAxis':'1'},
        {xAxis:'2019.11.02','label':'标注222','yAxis':'0'}
      ]
    }, this.init)
  }

  init = () => {
    const {fields, list, colorList, axis, labelList, chartD3} = this.state;
    const colors = createListItem(colorList) 

    this.setState({
      chartHeight: calcPx(fields.chartHeight.value, 720),
      chartWidth: calcPx(fields.chartWidth.value, 1280),
      // chart: chart
    })
    // ------------------

    const barLabel = labelList.filter(item => item.yAxis === '0')
    const lineLabel = labelList.filter(item => item.yAxis !== '0')
    const barMap = list2obj(barLabel)
    const lineMap = list2obj(lineLabel)

    const option = {
      after: {
        ...fields,
        list,
        colorList,
        axis: axis,
        colors: Object.keys(colors),
        labelList
      },
      height: calcPx(fields.chartHeight.value, 720),
      width: calcPx(fields.chartWidth.value, 1280),
      barMap,
      lineMap,
      lineSpace: 5,
      barColor: colorList[0].color,
      lineColor: colorList[1].color,
      labelLineColor: colorList[2].color,
      barLabelColor: colorList[3].color,
      lineLabelColor: colorList[4].color,
      data: list
      .filter(item => item.name !== '' && item.agreeable !== undefined && item.neutrality !== undefined)
      .map(item => {
        return {
          title: item.name,
          bar: item.agreeable - 0,
          line: item.neutrality - 0
        }
      })
    }

    if (!chartD3) {
      const chart = new multiaxisD3(this.chartRef, option)
      this.setState({
        chartD3: chart
      })
    } else {
      chartD3.reload(option)
    }
  }

  handleFormChange (props, changedFields) {
    this.setState(({ fields }) => ({
      fields: {
        ...fields,
        ...changedFields
      }
    }));
  }

  handleAdd (props, changedFields) {
    if (isArray(changedFields)) {
      this.setState({
        list: changedFields
      })
    } else {
      this.setState({
        ...changedFields
      })
    }
  }

  handleClick () {
    // const {chartD3} = this.state
    this.init()
  }

  exportSvg = (e) => {
    const svg = e.target.nextElementSibling
    svg.setAttribute("version", 1.1)
    svg.setAttribute("xmlns", "http://www.w3.org/2000/svg")
    const html = svg.outerHTML
    const str = window.btoa(unescape(encodeURIComponent(html)))

    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')

    const image = document.createElement('img')
    image.onload = function () {
      canvas.width = image.width
      canvas.height = image.height
      ctx.drawImage(image, 0, 0);
      saveFile(convertCanvasToImage(canvas).src, '下载')
    }
    image.src = 'data:image/svg+xml;base64,'+ str
    // document.body.appendChild(canvas)
    // saveFile(convertCanvasToImage('data:image/png;base64,'+ str).src, '下载')
  }

  render() {
    const {fields, list, colorList, chartWidth, chartHeight, chart, labelList} = this.state;

    return (
      <CustomChart width={chartWidth} height={chartHeight} chart={chart} chartPane={() => {
        return (
          <div ref={(ref) => this.chartRef = ref}>
            <div onClick={this.exportSvg} style={{
              position: 'absolute',
              top: 30,
              left: '100%',
              background: '#f1f1f1',
              minWidth: 80,
              padding: 5,
              boxShadow: '1px 0 3px #000',
              cursor: 'pointer',
              fontWeight: 600
            }}>导出</div>
          </div>
        )}}
        callback={this.handleClick}
      >
        <MultiaxisPane list={list} color={colorList} labelList={labelList} onChange={this.handleAdd} />
        <CustomizedForm {...fields} onChange={this.handleFormChange} />
      </CustomChart>
    )
  }
}

export default withStyles(s)(MultiaxisD3);



// WEBPACK FOOTER //
// src/routes/customChart/MultiaxisD3/index.js